export enum RiskProfile {
	Conservative = 'conservative',
	ModerateConservative = 'moderate_conservative',
	Moderate = 'moderate',
	ModerateAggressive = 'moderate_aggressive',
	Aggressive = 'aggressive'
}
